import { MoneyConstants } from "./moneyConstants";

export class MoneyFormatter {
  static moneyIntlFormatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  static fromBigCents = value => {
    return MoneyFormatter.moneyIntlFormatter.format(
      parseFloat(value.div(100).toFixed(MoneyConstants.DISPLAY_DECIMAL_PLACES)),
    );
  };
}
